<div><h2>Dashboard</h2><Status></Status><Timeline :showUptime="true"></Timeline></div>